function navbarOffset() {
    var compHeight = document.querySelector('#shopify-section-static-header').getBoundingClientRect().bottom;
    if (window.innerWidth < 901) {
        document.getElementById("mobile-menu").style.top = compHeight + "px";
    } else {
        document.getElementById("mobile-menu").style.top = "0px";
    }
}

window.onload = navbarOffset;
window.addEventListener('resize', navbarOffset);
window.onscroll = navbarOffset;

document.addEventListener('DOMContentLoaded', function () {
    var html = document.documentElement,
        body = document.body,
        mainMenuItemTop = document.querySelectorAll('.nav-item-top');

    mainMenuItemTop.forEach(function (item) {
        item.addEventListener('mouseenter', function () {
            if (this.classList.contains('_parent')) {
                body.classList.add('_submenu-opened');
            }
        });

        item.addEventListener('mouseleave', function () {
            if (this.classList.contains('_parent')) {
                body.classList.remove('_submenu-opened');
            }
        });
    });

    var showOnHoverElements = document.querySelectorAll('[data-show-on-hover]');
    showOnHoverElements.forEach(function (element) {
        element.addEventListener('mouseenter', function () {
            var parentMenu = this.closest('.nav-submenu'),
                target = parentMenu.querySelector('[data-show-on-hover-item="' + this.getAttribute('data-show-on-hover') + '"]');
            parentMenu.querySelectorAll('[data-show-on-hover-item]').forEach(function (el) {
                el.classList.remove('_show');
            });
            target.classList.add('_show');
        });
    });

    var toggleMobileMenuElements = document.querySelectorAll('[data-toggle-mobile-menu]');
    toggleMobileMenuElements.forEach(function (element) {
        element.addEventListener('click', function (event) {
            event.preventDefault();
            html.classList.toggle('_hide-scroll-mm');
            body.classList.toggle('_mobile-menu-opened');
            body.classList.remove('_mobile-submenu-opened');
            document.querySelectorAll('.nav-submenu-wrap').forEach(function (el) {
                el.classList.remove('_show');
            });
            document.querySelector('.nav-wrap').scrollTop = 0;
        });
    });

    var mobileMenuParents = document.querySelectorAll('.mobile-menu-item._parent .mobile-menu-link');
    mobileMenuParents.forEach(function (element) {
        element.addEventListener('click', function (event) {
            if (body.clientWidth < 901) {
                event.preventDefault();
                var menuItem = this.closest('.mobile-menu-item');
                menuItem.classList.toggle('_opened');
                var submenu = menuItem.querySelector('.mobile-menu-submenu');
                submenu.style.display = submenu.style.display === 'block' ? 'none' : 'block';
            }
        });
    });

    var submenuColorsParents = document.querySelectorAll('.submenu-colors-col._parent .submenu-title');
    submenuColorsParents.forEach(function (element) {
        element.addEventListener('click', function () {
            if (body.clientWidth < 901) {
                var parent = this.parentElement;
                parent.classList.toggle('_opened');
                var list = parent.querySelector('.submenu-colors-list');
                list.style.display = list.style.display === 'block' ? 'none' : 'block';
            }
        });
    });

    document.querySelectorAll('.nav-item-top._parent .nav-link-top').forEach(function (element) {
        element.addEventListener('click', function (event) {
            if (body.clientWidth < 901) {
                event.preventDefault();
                var parent = this.parentElement;
                parent.querySelector('.nav-submenu-wrap').classList.add('_show');
                body.classList.add('_mobile-submenu-opened');
                document.querySelector('.nav-wrap').scrollTop = 0;
            }
        });
    });

    document.querySelectorAll('.submenu-back').forEach(function (element) {
        element.addEventListener('click', function () {
            this.parentElement.classList.remove('_show');
            body.classList.remove('_mobile-submenu-opened');
        });
    });
});
